<gl-pro-modal (closeModal)="close(false)">
  <p class="info">{{ 'pro_message' | translate }}</p>
  @if (!isMobile) {
    <div class="buttons center">
      <button outline-button (click)="openPriceList()">{{ 'price_list' | translate }}</button>
    </div>
  }
</gl-pro-modal>
